// extracted by mini-css-extract-plugin
module.exports = {"reader":"e_Wfb"};